/**********************************************************************************************************************/
/* FILE: hafas_webapp_app.js                                                                                          */
/**********************************************************************************************************************/
// contstructor for webapp, declare global Hafas-Variables
var HafasWebview = function () {
  // Subscriptions für Webview initialisieren
  this.subscriptions.webviews(this);
  Hafas.bind(this.Controller.Webviews.init, this)(Hafas.Config.webview);
};

var HafasPolicy = function (params) {
  this.policy = {};
  if (typeof this.subscriptions.policy != 'undefined') {
    this.subscriptions.policy(this);
  }
  Hafas.getWebAppContext = function () {
    return 'policy';
  };
  this.Controller.Policy.init(params);
};

var HafasWebapp = function (params) {
  var _me = this;

  var model = {
    webappWrap: "HFS_WebApp",
    contentContainer: 'HFS_PageContent',
    pageHeader: 'HFS_PageHeader',
    pageFooter: 'HFS_PageFooter',
    forceLayoutClass: Hafas.Config.UI.forceLayoutClass,
    layoutClass: Hafas.Config.UI.layoutClass,
    layoutMode: Hafas.Config.layoutMode,
    formContainer: 'HFS_DocumentFormWrapper',
    formUIHiddenActions: null,
    resultOverviewContainer: 'HFS_DocumentResultOverview',
    resultDetailContainer: 'HFS_DocumentDetailOverview',
    additionalContainer: 'HFS_DocumentAdditionalContainer',
    mapContainer: 'HFS_PageMap',
    mapHeaderContainer: 'HFS_PageMapHeader',
    mapSideDrawer: 'HFS_PageSideDrawer',
    mapSideDrawerTrigger: 'HFS_PageSideDrawerTrigger',
    mapSideDrawerTriggerMobile: 'HFS_MapOptioneMobileButton',
    templateBasePath: Hafas.Config.templatePath,
    appContext: Hafas.Config.startingAppContext,
    mapId: 'hfsWebappMap',
    smartLocationsContainer: 'HFS_DocumentSmartLocationsWrapper'
  };

  if (params.hasOwnProperty('options')) {
    model.options = params.options;
  }

  this.init(model);

  Hafas.getWebAppContext = function () {
    return _me.appContext + '';
    // neue Stringinstanz. Manipulation über DevTools-Consolen sind jetzt
    // nicht mehr möglich
  };

};

// init methods
HafasWebapp.prototype.init = function (options) {
  // now we can use "this" for applicationwide properties and methods

  // Check if the URL contains a "ds" parameter
  Hafas.Modules.JumpIn.checkAndResolveDataStoreId();

  // store target container in this (id is stored not the element!)
  this.webappWrap = options.webappWrap;
  this.content = options.contentContainer;
  this.pageHeader = options.pageHeader;
  this.showPageHeader = Hafas.Config.UI.showPageHeader;
  this.pageFooter = options.pageFooter;
  this.layoutClass = options.layoutClass;
  this.forceLayoutClass = options.forceLayoutClass;
  this.formContainer = options.formContainer;
  this.formUIHiddenActions = options.formUIHiddenActions;
  this.resultOverviewContainer = options.resultOverviewContainer;
  this.resultDetailContainer = options.resultDetailContainer;
  this.additionalContainer = options.additionalContainer;
  this.mapContainer = options.mapContainer;
  this.mapHeaderContainer = options.mapHeaderContainer;
  this.mapSideDrawer = options.mapSideDrawer;
  this.mapSideDrawerTrigger = options.mapSideDrawerTrigger;
  this.mapSideDrawerTriggerMobile = options.mapSideDrawerTriggerMobile;
  this.mapId = options.mapId;
  this.mediaQueries = options.mediaQueries;
  this.mq = null; // -> initial value before resize-event fires, resize returns xs, sm, md, lg, xlg
  this.smartLocationsContainer = options.smartLocationsContainer;

  if (options.hasOwnProperty('options')) {
    this.options = options.options;
  }

  // den vorhergegangenen appContext behalten.
  // wird in switchAppContext gesetzt
  this.prevContext = null;
  // important global var -> appContext
  this.appContext = options.appContext;

  // additional Containers like Trainroute have to hold a different context cause the additional containers are
  // are called from every appcontext
  this.additionalContext = null;

  this.templateBasePath = options.templateBasePath;

  // render credentials
  this.preloadTemplates(Hafas.bind(this.initController, this));
};

HafasWebapp.prototype.initController = function () {
  Hafas.Core.newType("hafasAtoms", {
    Controller: this.Controller
  });

  // render Base HTML
  this.renderInitialElements();

  // register Events
  this.registerEvents();

  // subscriptions for Event-Loop
  if (typeof this.subscriptions.custom != 'undefined') {
    this.subscriptions.custom(this);
  }
  if (typeof this.subscriptions.livemap != 'undefined') {
    this.subscriptions.livemap(this);
  }
  if (typeof this.subscriptions.map != 'undefined' && Hafas.Config.Switches.useMap == true) {
    this.subscriptions.map(this);
  }
  if (typeof this.subscriptions.Reachability != 'undefined') {
    this.subscriptions.Reachability(this);
  }
  if (((typeof Hafas.Config.SQ.useInToolbox && Hafas.Config.SQ.useInToolbox == true) || Hafas.Config.Switches.useStationboard == true) && typeof this.subscriptions.sq != 'undefined') {
    this.subscriptions.sq(this);
  }
  if (Hafas.Config.Switches.useTravelplanner == true && typeof this.subscriptions.tp != 'undefined') {
    this.subscriptions.tp(this);
  }
  if (typeof this.subscriptions.tq != 'undefined') {
    this.subscriptions.tq(this);
  }
  if (typeof this.subscriptions.app != 'undefined') {
    this.subscriptions.app(this);
  }
  if (typeof this.subscriptions.debug != 'undefined') {
    this.subscriptions.debug(this);
  }
  if (typeof this.subscriptions.common != 'undefined') {
    this.subscriptions.common(this);
  }
  if (typeof this.subscriptions.options != 'undefined') {
    this.subscriptions.options(this);
  }
  if (typeof this.subscriptions.apis != 'undefined') {
    this.subscriptions.apis(this);
  }
  if (Hafas.Config.showExceptions == true && typeof this.subscriptions.exceptions != 'undefined') {
    this.subscriptions.exceptions(this);
  }
  if (typeof this.subscriptions.suggest != 'undefined') {
    this.subscriptions.suggest(this);
  }
  if (typeof this.subscriptions.forms != 'undefined') {
    this.subscriptions.forms(this);
  }
  if (typeof this.subscriptions.Inputgen != 'undefined') {
    this.subscriptions.Inputgen(this);
  }
  if (typeof this.subscriptions.Push != 'undefined') {
    this.subscriptions.Push(this);
  }
  if (typeof this.subscriptions.JourneyCourse != 'undefined') {
    this.subscriptions.JourneyCourse(this);
  }
  if (typeof this.subscriptions.LineSearch != 'undefined') {
    this.subscriptions.LineSearch(this);
  }
  if (typeof this.subscriptions.HimSearch != 'undefined') {
    this.subscriptions.HimSearch(this);
  }
  if (typeof this.subscriptions.EventSearch != 'undefined') {
    this.subscriptions.EventSearch(this);
  }
  if (typeof this.subscriptions.TariffSearch != 'undefined') {
    this.subscriptions.TariffSearch(this);
  }
  if (typeof this.subscriptions.Lines != 'undefined') {
    this.subscriptions.Lines(this);
  }
  if (typeof this.subscriptions.TariffWizard != 'undefined') {
    this.subscriptions.TariffWizard(this);
  }
  if (Hafas.Config.Switches.useTRM == true && typeof this.subscriptions.TRM != 'undefined') {
    this.subscriptions.TRM(this);
  }

  if (typeof this.subscriptions.ExternalData != 'undefined') {
    this.subscriptions.ExternalData(this);
  }

  if (Hafas.Config.Switches.useFavorites) {
    if (typeof this.subscriptions.favorites != 'undefined') {
      this.subscriptions.favorites(this);
    }
  }

  if (Hafas.Config.Switches.useSmartLocations === true) {
    if (typeof this.subscriptions.smartLocations != 'undefined') {
      this.subscriptions.smartLocations(this);
    }
  }

  if (Hafas.Config.Switches.useTimetable) {
    if (typeof this.subscriptions.Timetable(this) != 'undefined') {
      this.subscriptions.Timetable(this);
    }
  }

  if (Hafas.Config.initAnalysisMode) {
    if (typeof this.subscriptions.analysis(this) != 'undefined') {
      this.subscriptions.analysis(this);
    }
  }

  if (typeof this.subscriptions.mapsearch != 'undefined') {
    this.subscriptions.mapsearch(this);
  }

  // subscriptions for UI/UX depends on layoutMode (fullmap | classic)
  if (typeof this.subscriptions.GUI != 'undefined') {
    this.subscriptions.GUI(this);
  }

  // subscriptions for PRINT depends on layoutMode (fullmap | classic)
  if (typeof this.subscriptions.PRINT != 'undefined') {
    this.subscriptions.PRINT(this);
  }

  if (typeof this.subscriptions.Imprint != 'undefined') {
    this.subscriptions.Imprint(this);
  }
  /* Profi Umweltvergleich */
  if (typeof this.subscriptions.ecocheck != 'undefined') {
    this.subscriptions.ecocheck(this);
  }

  /* Specific subscriptions for FormBased Planner */
  if(Hafas.Config.Styling.theme == 'formbased'){
    this.subscriptions.FormBased(this);
  }

  this.Controller.Favorites.main = this;

  var _application = '';
  if (typeof Hafas.Config.CustomerObj != 'undefined' && Hafas.Config.CustomerObj !== null) {
    _application = Hafas.Config.Storage.id+ '_' + Hafas.Config.CustomerObj.name
  }
  else {
    _application = Hafas.Config.Storage.id;
  }

  // Hide pageContent if configured this way (after subscriptions have been initialized, but before JumpIn)
  if (!Hafas.Config.UI.showPageContentOnInit && !Hafas('#HFS_WebApp', false).classList.contains('layout-small')) {
    Hafas.ps.pub('/GUI/common/pageContentToggle',[{trigger: 'main', show: false}]);
  }

  // Can be used to modify values before evaluating them afterwards
  Hafas.Modules.JumpIn.checkHighPriorityParameters(); //

  // Get and set the default cookie settings
  var storage = Hafas.Core.newType("hafasStorage");
  var cookiesSetBy = "";
  var cookieAcceptance = storage.get(Hafas.Config.Storage.id+ '_cookieSettings');
  if (!cookieAcceptance || !Hafas.Config.UI.showCookieHint) {
    // We do not have cookie consent in storage or the hint is deactivated -> use all
    cookiesSetBy = "default";
    var defaultCookiesValues = !Hafas.Config.UI.showCookieHint;
    var defaultCookieSettings = {};
    for (var t = 0; t < Hafas.Config.Cookies.types.length; t++) {
      var type = Hafas.Config.Cookies.types[t];
      defaultCookieSettings[type.id] = (!type.disabled) ? defaultCookiesValues : type.checked; // Use default value only for non-disabled values, otherwise use the configured value
    }
    Hafas.Config.CookieSettings = defaultCookieSettings;
  } else {
    // We have cookie consent in storage -> use these
    cookiesSetBy = "storage";
    defaultCookieSettings = JSON.parse(cookieAcceptance);
    Hafas.Config.CookieSettings = defaultCookieSettings;
  }

  // Check if we have cookie settings via URL which have a higher priority to default / user choice and save them in the storage
  if (Hafas.Config.Cookies.consentCookies !== undefined) {
    cookiesSetBy = "param"
    var consentCookies = Object.keys(Hafas.Config.Cookies.consentCookies);
    for (var c = 0; c < consentCookies.length; c++) {
      Hafas.Config.CookieSettings[consentCookies[c]] = Hafas.Config.Cookies.consentCookies[consentCookies[c]];
    }

    // We have to write the final cookie settings into the storage, as the storage is read later on for rendering the hint
    storage.set(Hafas.Config.Storage.id+ '_cookieSettings', JSON.stringify(Hafas.Config.CookieSettings))
  }

  if (Hafas.Modules.IFrameApi && Hafas.Modules.IFrameApi.externalCookieManagerActive === true) {
    // ExternalCookieManager enabled in HafasIframe/iframe api, notify the parent page to show the cookie banner
    Hafas.Modules.IFrameApi.sendInitialCookieSettingsCallback();
  } else {
    // Default webapp cookie banner
    // Render the cookie hint in case it should be shown initially or when the user has the options to change cookie settings later on
    if (Hafas.Config.UI.showInitialCookieHint === true || Hafas.Config.UI.showCookieHint === true) {
      Hafas.ps.pub('/gui/renderCookieHint');
    }

    // Only show if it should be shown initially
    // showInitialCookieHint can be set via URL param -> then force to show or to hide it
    // But it can be also set by config to show only once -> do not show it when we have user choice
    if (Hafas.Config.UI.showInitialCookieHint) {
      if (Hafas.Config.Cookies.forceInitialCookieHint === true || cookiesSetBy === "default") {
        // URL param forces to show it OR there hasn't been a user choice
        Hafas.ps.pub('/app/showCookieSettings', [{toggleFlyout: false}])
      }
    }
  }

  var enableFavorites = true;

  if(Hafas.Util.isCookieTypeActive('functional')) {
    Hafas.Modules.Suggest.enableSuggestStorage();
  } else {
    // SuggestStorage is initially disabled
    enableFavorites = false;
  }

  if(Hafas.Util.isCookieTypeActive('performance')) {
    Hafas.Core.initTracker();
  }

  // Create favorites instance
  this.Controller.Favorites.instance = Hafas.Core.newType("hafasFavorites", {
    maxLocations: Hafas.Config.Favorites.maxLocations,
    maxLocationsHistory: Hafas.Config.Favorites.maxLocationsHistory,
    maxConnections: Hafas.Config.Favorites.maxConnections,
    maxConnectionsHistory: Hafas.Config.Favorites.maxConnectionsHistory,
    maxLines: Hafas.Config.Favorites.maxLines,
    maxLinesHistory: Hafas.Config.Favorites.maxLinesHistory,
    application: _application,
    enabled: enableFavorites
  });
  // Error handling of outdated favorites structure
  if (this.Controller.Favorites.instance !== undefined && this.Controller.Favorites.instance.validDataVersion === false) {
    this.Controller.Favorites.instance.updateFavoritesDataModel();
  }

  /* Produktvorauswahl aus Config */
  var prodClassTP = 0;
  for (var p = 0; p < Hafas.Config.productClasses.length; p++) {
    if (Hafas.Config.productClasses[p].value) {
      prodClassTP += Hafas.Config.productClasses[p].bit;
    }
  }

  if (Hafas.Config.Switches.useTravelplanner) {
    // Wenn Optionen ausgeschaltet sind, diese nicht in den Favoriten zulassen
    if(!Hafas.Config.TP.useQueryOptions) {
      Hafas.Config.Favorites.storeQueryOptions = false;
    }
    // Clusteraufbereitung
    this.Controller.TP.main = this;
    this.Controller.TP.instance = Hafas.Core.newType("hafasTP", {
      id: 'webapp',
      outDate: Hafas.Config.serverDate,
      outTime: Hafas.Config.serverTime,
      useGrouping: Hafas.Config.TP.useGrouping,
      cls: prodClassTP,
      cluster: Hafas.Core.clone(Hafas.Config.TP.cluster)
    });
    if (Hafas.Config.TP.useQueryOptions) {
      var tpOptionModel = {
        application: 'TP',
        model: this.options['TP'],
        instance: this.Controller.TP.instance
      };
      //Optionen zur manuellen Einstellung der IV-Distanzen herausnehmen, wenn Multimodal eingeschaltet ist
      // ngr 2020-06-16: Wird entfernt, allerdings darf "enabled" für Distanzen nicht mitgeschickt werden!
      /*if (Hafas.Config.TP.useGrouping) {
        tpOptionModel.modL = [
          // bei aktivierten Clustern sollen keine IV-Distanzen einstellbar sein, weil diese zur falschen Anzeige von Clustern führen
          {
            for: 'hciType',
            parameter: 'gisProfile',
            change: {key: 'ctxFilter', value: '{"TP": "HIDDEN"}'}
          },
          // wenn es wg. der Cluster keine IV-Distanzeinstellungen gibt, ist die Option "Geschwindigkeit" nicht ausgegraut
          {
            for: 'meta',
            parameter: 'speed',
            change: {key: 'state', value: ''}
          }
        ];
      }*/
      this.Controller.TP.options = Hafas.Core.newType("HafasOptions", tpOptionModel);
    }
  }

  // Stationboard
  if (Hafas.Config.Switches.useStationboard == true) {
    var sortType = 'line';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.sortType != 'undefined') {
      sortType = Hafas.Config.SQ.sortType;
    }
    var timeMode = 'time';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.timeInfoMode != 'undefined') {
      timeMode = Hafas.Config.SQ.timeInfoMode;
    }
    var autorefresh = false;
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.autorefresh != 'undefined') {
      autorefresh = Hafas.Config.SQ.autorefresh;
    }
    var updateInterval = 60000;
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.updateInterval != 'undefined') {
      updateInterval = Hafas.Config.SQ.updateInterval;
    }
    var sqRequestSort = 'PT';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.sort != 'undefined') {
      sqRequestSort = Hafas.Config.SQ.sort;
    }
    this.Controller.SQ.main = this;
    var prodClassSQ = 0;
    for (var p = 0; p < Hafas.Config.productClasses.length; p++) {
      prodClassSQ += Hafas.Config.productClasses[p].bit;
    }

    _enrichProductsForQuickFilter = function(stopFilter) {
      stopFilter.forEach(function (item) {
        // Match to client config to retrieve label text for quick filter product
        // (only needed if it's not generated by the server)
        if (item.product === undefined) {
          var productClassMatchToLocalConfig = Hafas.Util.products.getProductConfigForClass(item.bit);
          if (productClassMatchToLocalConfig != null) {
            item.product = productClassMatchToLocalConfig;
            // bei nicht auslesbaren Produkttexten auf die aus der stopFilter-Liste zurückgreifen
            if (item.product == null && typeof item.nameL != "undefined") {
              item.product = {nameLong: item.nameL};
            }
          }
        }
      });
    }

    // Setup request quick filter for stationboard
    var stopFilterRequest = Hafas.Core.clone(Hafas.Config.SQ.stopFilterRequest);
    _enrichProductsForQuickFilter(stopFilterRequest);
    this.Controller.SQ.fltrL = stopFilterRequest;

    // Setup result quick filter for stationboard
    var stopFilterResult = Hafas.Core.clone(Hafas.Config.SQ.stopFilterResults);
    _enrichProductsForQuickFilter(stopFilterResult);

    this.Controller.SQ.instance = Hafas.Core.newType("hafasStboard", {
      id: 'webapp',
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime,
      prodclasses: prodClassSQ,
      showJourneys: 40,
      sortType: sortType,
      timeInfoMode: timeMode,
      autorefresh: autorefresh,
      updateInterval: updateInterval,
      sort: sqRequestSort,
      fltrL: stopFilterResult
    });
    if (Hafas.Config.SQ.useQueryOptions) {
      this.Controller.SQ.options = Hafas.Core.newType("HafasOptions", {
        application: 'SQ',
        model: this.options['SQ'],
        instance: this.Controller.SQ.instance
      });
    }
  }

  // Tarifauskunft
  if (Hafas.Config.Switches.useTariffSearch) {
    this.Controller.TariffSearch.main = this;
    this.Controller.TariffSearch.instance = Hafas.Core.newType("hafasTariffSearch", {
      id: 'webapp',
      outDate: Hafas.Config.serverDate,
      outTime: Hafas.Config.serverTime,
      trfCtx: unescape(Hafas.Config.TariffSearch.trfCtx)
    });
  }

  // Tarifberater
  if (Hafas.Config.Switches.useTariffWizard) {
    this.Controller.TariffWizard.main = this;
    this.Controller.TariffWizard.instance = Hafas.Core.newType("hafasTariffWizard", {
      id: 'webapp'
    });
  }

  if (Hafas.Config.Switches.useLineSearch == true) {
    this.Controller.LineSearch.main = this;
    this.Controller.LineSearch.instance = Hafas.Core.newType("hafasLineSearch", {
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime
    });

    var lineFilter = Hafas.Core.clone(Hafas.Config.LineSearch.lineFilter);
    lineFilter.forEach(function (item) {
      item.product = Hafas.Util.products.getProductConfigForClass(item.bit);
    });

    this.Controller.LineSearch.lineFilter = lineFilter;
  }

  if (Hafas.Config.Switches.useTimetable == true) {
    this.Controller.Timetable.main = this;
    this.Controller.Timetable.instance = Hafas.Core.newType("hafasTimetable", {});
    this.Controller.Timetable.linesearch = Hafas.Core.newType("hafasLineSearch", {
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime
    });
  }

  if (Hafas.Config.initAnalysisMode == true) {
    this.Controller.Analysis.main = this;
    this.Controller.Analysis.instance = Hafas.Core.newType("hafasAnalysis", {});
  }

  // Maps
  if (Hafas.Modules.Maps && this.Controller.Map && this.mapId !== null && Hafas.Config.Switches.useMap == true) {
    this.Controller.Map.main = this;
    var initCoord = Hafas.Core.newType("hafasCCoord", {
      lon: Hafas.Config.Maps.predefinedArea.lon,
      lat: Hafas.Config.Maps.predefinedArea.lat
    });
    var attribution = '';
    if(Hafas.Config.Cookies.showMapLink){
      attribution += '<a href="#" onclick="Hafas.ps.pub(\'/app/showCookieSettings\',[{\'toggleFlyout\':false}]);return false;">' + Hafas.Modules.i18n.get('Cookies.t_N_CookieSettingsMapLink') + ' </a>';
    }
    var mapConfigParams = {
      coord: initCoord,
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: Hafas.Config.Switches.useReverseLookup,
      attribution: attribution,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.Maps.staticTileURL,
        "attribution": '&copy; OpenStreetMap contributors',
        "isBaseLayer": true
      }],
      lazyLoadTiles: true,
      baseLayer: Hafas.Config.Maps.baseLayer
    };
    if(typeof Hafas.Config.Maps.vectorStyle != 'undefined'){
      mapConfigParams.style = Hafas.Config.Maps.vectorStyle;
    }
    if (typeof Hafas.Config.Maps.controls != 'undefined') {
      mapConfigParams.controls = Hafas.Config.Maps.controls;
    }

    mapConfigParams.useContextmenu = Hafas.Config.Maps.useContextmenu;

    Hafas.ps.sub("/map/show/hfsWebappMap", Hafas.bind(function (mapInstance) {
      this.Controller.Map.mobilityRadar = Hafas.Core.newType("hafasMobilityRadar", {
        map: mapInstance,
        id: 'webapp',
        showstops: true
      });
      this.Controller.MapSearch.init();

      // Tracking
      Hafas.ps.pub('/tracking/screen/mobility-map-main', [{typ: 'screen', key: 'mobility-map-main'}]);

      // Save initial map view, so it can be restored at a later time (e.g. when the map tab is clicked)
      this.Controller.Map.saveInitialMapView.bind(this,mapInstance)();
    }, this));

    // Initial calculation of the map container, otherwise the map has height 0 at initialization
    Hafas('#' + this.mapContainer, false).style.height = window.innerHeight + "px";

    var map = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, 'hfsWebappMap', mapConfigParams);
    this.Controller.Map.instance = map;

    if (Hafas.Config.Switches.useLivemap) {
      this.Controller.Livemap.main = this;
      Hafas.bind(this.Controller.Livemap.index, this)();
      // Independently of the config switch "autostart", the livemap must also be activated
      // if a product was initially switched on for the livemap (e.g. by server)
      var startLivemapInitially = false;
      var livemapProductList = Hafas.Util.products.getForContext("Livemap");
      for (var i in livemapProductList) {
        if (livemapProductList[i].checked === true) {
          startLivemapInitially = true;
          break;
        }
      }
      if (Hafas.Config.Livemap.autostart || startLivemapInitially) {
        this.Controller.Livemap.startLivemap();
      }
    }
    if (this.Controller.CustomToolbox)
      this.Controller.CustomToolbox.index();
    if (this.Controller.ExternalData)
      this.Controller.ExternalData.index(this);
  }

  // Proximity search
  if (Hafas.Config.Switches.useReachability == true) {
    this.Controller.Reachability.main = this;
    this.Controller.Reachability.instance = Hafas.Core.newType("hafasReachability", {
      id: 'webapp',
      map: this.Controller.Map.instance,
      input: 'ReachabilityLocation',
      traveltime: Hafas.Config.Reachability.initialDuration,
      period: Hafas.Config.Reachability.period
    });
    if (Hafas.Config.Reachability.useQueryOptions) {
      this.Controller.Reachability.options = Hafas.Core.newType("HafasOptions", {
        application: 'Reachability',
        model: this.options['Reachability'],
        instance: this.Controller.Reachability.instance
      });
    }
  }

  if (Hafas.Config.Switches.useTRM) {
    this.Controller.TRM.init();
  }
  if (Hafas.Config.Switches.usePush) {
    this.Controller.Push.init();

    // Prüfen ob es
    var storage = Hafas.Core.newType("hafasStorage");
    var alarmUserData = storage.get('alarmUser_' + Hafas.Config.Storage.id);

    if(alarmUserData != null) {
      var alarmUser = JSON.parse(alarmUserData);
      this.Controller.Push.revitalizeUserId({userId: alarmUser.userId, hideErrorPopup: true, hidePopup: true});
    }else{
      // Es gibt keinen Alarm-User? Dann in jedem Falle, Subscriptions und Kanaldaten aus dem LocalStorage löschen
      storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
      storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);
    }
  }

  if (Hafas.Util.checkPath(Hafas.Config, 'Push.channels.webpush') === true && Hafas.Config.Push.channels.webpush.use === true) {
    // If there is any functionality activated that uses push, we should init the service worker directly at the start
    try {
      if (Hafas.Util.detectApnsPush() === true) {
        // No PushManager available (VAPID / web push standard), use APNS
        var permissionData = window.safari.pushNotification.permission(Hafas.Config.Push.channels["webpush"].applePushID);
        if (permissionData.permission === "granted") {
          Hafas.Config.Push.clientEndpoint = permissionData.deviceToken;
          Hafas.Config.Push.useDirectEndpoint = true; // APNS
        }
      } else {
        Hafas.Config.Push.useDirectEndpoint = false; // VAPID
        // Creates a clientEndpoint if possible via service worker via pushManager
        Hafas.Util.worker.setUpServiceWorker();
      }
    } catch (e) {
      // Error in setting up the service worker, e.g. on Safari on old Mac
      Hafas.Util.worker.handlePushPermission(true, true);
    }
  }

  // Stoerungskarte HimSearch
  if (Hafas.Config.Switches.useHimSearch) {
    this.Controller.HimSearch.instance = Hafas.Core.newType("hafasHimSearch", {
      map: this.Controller.Map.instance,
      useMap: Hafas.Config.Switches.useMap,
      hideMessagesWithoutGeoInformation: Hafas.Config.HimSearch.hideMessagesWithoutGeoInformation
    });
    if (Hafas.Config.HimSearch.useQueryOptions) {
      this.Controller.HimSearch.options = Hafas.Core.newType("HafasOptions", {
        application: 'HimSearch',
        model: this.options['HimSearch'],
        instance: this.Controller.HimSearch.instance
      });
    }
  }

  // Eventliste/-suche
  if (Hafas.Config.Switches.useEventSearch) {
    this.Controller.EventSearch.instance = Hafas.Core.newType("hafasEventSearch", {map: this.Controller.Map.instance});
  }

  // Line news
  if (Hafas.Config.Switches.useLines) {
    this.Controller.Lines.instance = Hafas.Core.newType("hafasLines", {});
  }

  // Prüfen ob Start-Parameter initial gesetzt ist, Hilfsflag im zugehörigen Controller ergänzen
  if(Hafas.Util.checkWebAppUrlParameter('start')){
    this.Controller.Common.initialStartSet = true;
  }

  /* HIM Instanz anlegen wenn Funktionalitaet eingeschaltet ist */
  if (Hafas.Config.Switches.useHimInterface) {
    this.himInterface = Hafas.Core.newType("hafasHimInterface", {
      version: Hafas.Config.HIM.version
    });
  }

  if (Hafas.Core.getParameterByName("ctxRecon") != null) {
    var ctxRecon = Hafas.Core.getParameterByName("ctxRecon");
    this.Controller.TP.reconstructConnection = ctxRecon;
  }

  // Auf fullscreen events reagieren und publishen
  function triggerHafasFullscreenEvent(event) {
    Hafas.ps.pub('/GUI/fullscreen/changed', [Hafas.Util.fullscreen.isActive(), event]);
  }

  document.addEventListener('fullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('webkitfullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('mozfullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('MSFullscreenChange', triggerHafasFullscreenEvent);

  var components = Hafas.Modules.Components;
  var webappContainer = Hafas('#HFS_WebApp');

  // register tooltips globally so they don't have to be created individually
  components.HafasTooltip.applyTo({
    containerClassName: 'lyr_tooltip',
    eventContainer: window,
    tooltipContainerParent: webappContainer
  });


  // create containers for accessible announcements (aria-live regions)
  Hafas.Modules.a11y.Announce.init(webappContainer);
  // Als Letztes den Loader ausblenden, wenn ein Splashscreen verwendet wurde
  if (typeof Hafas.Config.Switches.useSplashScreen != 'undefined' && Hafas.Config.Switches.useSplashScreen === true) {
    var $loader = Hafas('#HFS_Splashscreen', false);
    if ($loader) {
      $loader.addEventListener('transitionend', function () {
        Hafas.Util.gui.setSRVisibility($loader, false);
      });
      $loader.style.opacity = 0;
    }
  }

  Hafas.Modules.JumpIn.jumpInStartContext();

  // After GUI controller is loaded and the layout class initialized, check if we have to load the map layers directly
  var layoutClass = Hafas.bind(this.Controller.GUI.common.getLayoutClass, this)();
  if (layoutClass !== "small") {
    Hafas.ps.pub('/map/initLayer');
  }

  Hafas.ps.pub('/app/updateBanner', ["map"]);

};
